<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24" type="flex">
            <a-col flex="450px">
                <a-form-item label="类型">
                  <a-radio-group @change="changeLogType">
                    <a-radio-button key="" :value="undefined">全部</a-radio-button>
                    <a-radio-button key="1" :value="1">切屏</a-radio-button>
                    <a-radio-button key="3" :value="3">拍照</a-radio-button>
                    <a-radio-button key="4" :value="4">录像</a-radio-button>
                    <a-radio-button key="5" :value="5">录屏</a-radio-button>
                    <a-radio-button key="6" :value="6">行为</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col flex="300px">
                <a-form-item label="状态">
                  <a-radio-group @change="changeLogWarning">
                    <a-radio-button key="" :value="undefined">全部</a-radio-button>
                    <a-radio-button key="1" :value="1">异常</a-radio-button>
                    <a-radio-button key="3" :value="0">正常</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col flex="300px" v-if="queryParam.logType==3||queryParam.logType==4||queryParam.logType==5">
                <a-form-item label="每行数量">
                  <a-radio-group v-model="rowNum" @change="searchQuery">
                    <a-radio-button key="1" :value="1">1</a-radio-button>
                    <a-radio-button key="2" :value="2">2</a-radio-button>
                    <a-radio-button key="4" :value="4">4</a-radio-button>
                    <a-radio-button key="6" :value="6">6</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col flex="300px" v-if="queryParam.logType==4||queryParam.logType==5">
                <a-form-item label="播放速度">
                  <a-radio-group v-model="playbackRate">
                    <a-radio-button key="0.5" :value="0.5">0.5</a-radio-button>
                    <a-radio-button key="1" :value="1.0">1</a-radio-button>
                    <a-radio-button key="2" :value="2.0">2</a-radio-button>
                    <a-radio-button key="4" :value="4.0">4</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
  
      <!-- 操作按钮区域 -->
      <!-- <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        <a-button type="primary" icon="download" @click="handleExportXls('teaching_user_paper_log')">导出</a-button>
        <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div> -->
  
      <!-- table区域-begin -->
      <div>
        <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div> -->
        <a-table
          v-if="queryParam.logType==undefined || queryParam.logType == 1 || queryParam.logType == 6"
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          class="j-table-force-nowrap"
          @change="handleTableChange">
  
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgView(text)" :preview="text" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
          </template>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(text)">
              查看
            </a-button>
          </template>
          <template slot="warning" slot-scope="warning">
            <a-icon class="warning-icon" v-if="warning==1" style="color:red" type="warning" />
            <a-icon class="warning-icon" v-else style="color:green" type="smile" />
          </template>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm v-if="record.warning==0" title="确定要编辑为异常吗?" @confirm="()=>markWarning(record.id)">
              <a>标记异常</a>
            </a-popconfirm>
            <a-popconfirm v-if="record.warning==1" title="确定要编辑为正常吗?" @confirm="()=>markNormal(record.id)">
              <a>标记正常</a>
            </a-popconfirm>
            <!-- <a-divider type="vertical" />
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">详情</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown> -->
          </span>
        </a-table>
  
        <div v-else>
          <a-row >
            <a-col :span="24/rowNum" v-for="(d,i) in dataSource" :key="i">
              <a-card :class="[d.warning==1?'warning-border':'', 'view-card']" :hoverable="true">
                <img preview="1" v-if="queryParam.logType == 3" :src="d.fileUrl_url" alt="">
                <!-- <video v-else :src="d.fileUrl_url" controls></video> -->
                <PreviewVideo v-else :src="d.fileUrl_url" :playbackRate="playbackRate" hoverPlay controls/>
                <template class="ant-card-actions" slot="actions">
                  <span>{{formatTime(d.duration)}}</span>
                  <a-icon class="warning-icon" v-if="d.warning==1" style="color:red" type="warning" />
                  <a-icon class="warning-icon" v-else style="color:green" type="smile" />
                  <a-popconfirm v-if="d.warning==0" title="确定要编辑为异常吗?" @confirm="()=>markWarning(d.id)">
                    <a>标记异常</a>
                  </a-popconfirm>
                  <a-popconfirm v-if="d.warning==1" title="确定要编辑为正常吗?" @confirm="()=>markNormal(d.id)">
                    <a>标记正常</a>
                  </a-popconfirm>
                </template>
              </a-card>
            </a-col>
          </a-row>
          <a-divider></a-divider>
          <a-pagination
            @change="pageChange"
            :current="ipagination.current" 
            :pageSize="ipagination.pageSize"
            :pageSizeOptions="ipagination.pageSizeOptions"
            :showTotal="ipagination.showTotal"
            :total="ipagination.total"
            showQuickJumper
            showSizeChanger
            />
        </div>
      </div>
  
      <!-- <teaching-user-paper-log-modal ref="modalForm" @ok="modalFormOk"></teaching-user-paper-log-modal> -->
    </a-card>
  </template>
  
  <script>
  
    import '@/assets/less/TableExpand.less'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { getAction, postAction } from '@/api/manage'
    // import TeachingUserPaperLogModal from './modules/TeachingUserPaperLogModal'
    import PreviewVideo from '@/components/tools/PreviewVideo'
    export default {
      name: 'TeachingUserPaperLogList',
      mixins:[JeecgListMixin, mixinDevice],
      components: {
        // TeachingUserPaperLogModal,
        PreviewVideo
      },
      data () {
        return {
          description: '监考数据',
          // 表头
          columns: [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:'类型',
              align:"center",
              dataIndex: 'logType',
              customRender(v){
                switch(v){
                  case 1: return '跳出页面'
                  case 2: return '回到页面'
                  case 3: return '抓拍'
                  case 4: return '录像'
                  case 5: return '录屏'
                  case 6: return '行为'
                  default: return v
                }
              }
            },
            {
              title:'日志内容',
              align:"center",
              dataIndex: 'logContent',
            },
            {
              title:'记录时间',
              align:"center",
              dataIndex: 'createTime',
              customRender:function (text) {
                return text
              }
            },
            {
              title:'是否异常',
              align:"center",
              dataIndex: 'warning',
              scopedSlots: { customRender: 'warning' }
            },
            {
              title:'考试进度',
              align:"center",
              dataIndex: 'duration',
              customRender(time){
                 var minutes = Math.floor(time / 60);
                 var seconds = Math.floor(time % 60);
                 return minutes + ":" + seconds
              }
            },
            {
              title:'文件记录',
              align:"center",
              dataIndex: 'fileUrl_url',
              scopedSlots:{customRender: 'fileSlot'}
            },
            {
              title: '人工标记',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:100,
              scopedSlots: { customRender: 'action' }
            }
          ],
          isorter:{
            column: 'duration',
            order: 'asc',
          },
          url: {
            list: "/teaching/teachingUserPaperLog/list",
            delete: "/teaching/teachingUserPaperLog/delete",
            deleteBatch: "/teaching/teachingUserPaperLog/deleteBatch",
            exportXlsUrl: "/teaching/teachingUserPaperLog/exportXls",
            importExcelUrl: "teaching/teachingUserPaperLog/importExcel",
            
          },
          rowNum: 4, //每行显示数量
          playbackRate: 1.0, //播放速度
          dictOptions:{},
          disableMixinCreated: true
        }
      },
      created() {
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        },
      },
      methods: {
        initDictConfig(){
        },
        loadOk(){
          this.$previewRefresh()
        },
        showPaperLog(userPaperId){
          this.queryParam.userPaperId = userPaperId
          this.loadData(1)
        },
        changeLogWarning(e){
          this.queryParam.warning = e.target.value
          this.dataSource = []
          this.loadData(1)
        },
        changeLogType(e){
          this.queryParam.logType = e.target.value
          this.dataSource = []
          this.loadData(1)
        },
        pageChange(page, pageSize){
          this.dataSource = []
          this.ipagination.current = page
          this.ipagination.pageSize = pageSize
          console.log(this.queryParam);
          this.loadData()
        },
        //标记为异常
        markWarning(id){
          getAction("/teaching/teachingUserPaperLog/markWarning", {id:id, isWarning: 1}).then(res=>{
            if(res.success){
              this.$message.success("标记成功")
              this.loadData()
            }
          })
        },
        //标记为正常
        markNormal(id){
          getAction("/teaching/teachingUserPaperLog/markWarning", {id:id, isWarning: 0}).then(res=>{
            if(res.success){
              this.$message.success("标记成功")
              this.loadData()
            }
          })
        },
        formatTime(time) {
          var minutes = Math.floor(time / 60);
          var seconds = Math.floor(time % 60);
          return minutes + ":" + seconds
        },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>
  <style lang="less" scoped>
  
  .warning-icon{
    font-size:20px;cursor: pointer;
  }
  .warning-border{
    border: 1px solid red;
  }
  .view-card{
    margin:0 10px;
    /deep/.ant-card-body{
      padding:0;
      img{
        width:100%;
      }
      video{
        width:100%;
      }
      
    }
  }
  </style>